var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"side-settings"},[(_vm.where === 'email' || _vm.where === 'emailSms')?_c('EmailConfig'):_vm._e(),(_vm.where ==='link')?_c('LinkConfig'):_vm._e(),(_vm.where ==='toten')?_c('TotenConfig'):_vm._e(),(_vm.where ==='widget')?_c('WidgetConfig'):_vm._e(),(_vm.where ==='whatsapp')?_c('WhatsappConfig'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }